import Http from '../http'

export const index = (page, name) => Http.get(`/integrations?page=${page}${(name) ? '&name=' + name : ''}`, { headers: { Authorization: localStorage.token } })
export const store = (data) => Http.post('/integrations', { data }, { headers: { Authorization: localStorage.token } })
export const update = (id, data) => Http.patch(`/integrations/${id}`, { data }, { headers: { Authorization: localStorage.token } })
export const destroy = (id) => Http.delete(`/integrations/${id}`, { headers: { Authorization: localStorage.token } })
